// Copies text, preferring the async Clipboard API and falling back to the
// execCommand path for contexts where it is unavailable (insecure origins, some
// embedded browsers). Resolves true on success, false when both routes failed.
export async function copyToClipboard(text) {
  if (!text) return false

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // fall through to the legacy path
    }
  }

  return legacyCopy(text)
}

function legacyCopy(text) {
  const textarea = document.createElement("textarea")
  textarea.value = text
  textarea.style.position = "fixed"
  textarea.style.opacity = "0"
  document.body.appendChild(textarea)
  textarea.select()

  try {
    return document.execCommand("copy")
  } catch {
    return false
  } finally {
    document.body.removeChild(textarea)
  }
}
